module.exports = __webpack_public_path__ + "static/CleverDevOps-ed54e7622c37355c7d1f6e68ad593385.png";